import React, { useState, useEffect, useCallback } from 'react';
import { debounce } from 'lodash';
import moment from 'moment';

import Loading from '../../components/loading';
import './home.scss';
import Header from '../Header';
import Footer from '../../components/Footer';
import { Row, Col } from 'react-flexbox-grid';
import Nav from '../Nav';
import Tabs from '../Tabs';
import TableRankingTitle from '../TableRankingTitle';
import TableRankingIndividual from '../TableRankingIndividual';
import FilterModal from '../FilterModal';
import CollectKitModal from '../CollectKitModal';
import config from '../../config';
import {
  DEFAULT_DISTANCE_INDIVIDUAL,
  DEFAULT_DISTANCE_TEAM,
} from '../../utils/utils';
import { handleResponse, serializeQuery } from '../../utils/handleResponse';
import bannerMobile from '../../assets/images/banner-12h-mobile.jpg';
import bannerDesktop from '../../assets/images/banner-12h-desktop.jpg';
import wpicon from '../../assets/images/wpicon.png';

const TABS = ['INDIVIDUAL', 'EQUIPOS'];

const getLocalUser = () => {
  try {
    return JSON.parse(localStorage.getItem('userData') || 'null');
  } catch (e) {
    return null;
  }
};

const Home = ({ history }) => {
  const [showLoading, setShowLoading] = useState(false);
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [showCollectKitModal, setShowCollectKitModal] = useState(false);
  const [showSecondLoading, setShowSecondLoading] = useState(false);
  const [showIndividualFavoriteLoading, setShowIndividualFavoriteLoading] =
    useState(false);
  const [filterText, setFilterText] = useState('');
  const [individualFavorites, setIndividualFavorites] = useState([]);
  const [teamFavorites, setTeamFavorites] = useState([]);
  const [selectedGenderFilter, setSelectedGenderFilter] = useState(null);
  const [selectedTeamGenderFilter, setSelectedTeamGenderFilter] =
    useState(null);
  const [distanceFilter, setDistanceFilter] = useState(
    DEFAULT_DISTANCE_INDIVIDUAL,
  );
  const [distanceTeamFilter, setDistanceTeamFilter] = useState(
    DEFAULT_DISTANCE_TEAM,
  );

  const [changeIndividual, setChangeIndividual] = useState(null);

  const [lastUpdate, setLastUpdate] = useState(null);
  const [selectedTab, setSelectedTab] = useState(null);

  const favoritesEnabled = !!(
    getLocalUser()?.userToken && getLocalUser()?.user?.id
  );

  const resetFilters = () => {
    setSelectedGenderFilter(null);
    setSelectedTeamGenderFilter(null);
    if (filterText) {
      setFilterText('');
    } else {
      setChangeIndividual(new Date().getTime());
    }
  };

  const openIG = () => {
    const apiWs =
      window.innerWidth < 1024
        ? 'https://api.whatsapp.com/send?phone=573016428419&text=Hola+TNC%2c+estoy+inscrito+al+COLOMBIA+CHALLENGE+y+estoy+interesado+en+comprar+una+BMC+con+10%25+OFF%e2%80%a6'
        : 'https://web.whatsapp.com/send?phone=573016428419&text=Hola+TNC%2c+estoy+inscrito+al+COLOMBIA+CHALLENGE+y+estoy+interesado+en+comprar+una+BMC+con+10%25+OFF%e2%80%a6';
    window.open(apiWs, '_blank');
  };

  useEffect(() => {
    setSelectedTab(0);
    if (favoritesEnabled) {
      getIndividualFavorites();
      getTeamFavorites();
    }
  }, []);

  const debouncedTriggerSearch = useCallback(
    debounce(() => {
      setChangeIndividual(Date.now());
    }, 500),
    [],
  );

  useEffect(() => {
    debouncedTriggerSearch();
    return () => debouncedTriggerSearch.cancel();
  }, [filterText, debouncedTriggerSearch]);

  const getIndividualFavorites = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      return;
    }
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
    };
    const requestOptions = {
      method: 'GET',
      headers,
    };
    let url;

    url = new URL(
      `${config.tncApiUrl}/user-event/favorites?orderByTotalDistance=true`
    );

    url.searchParams.append('userId', athlete.user.id);
    url.searchParams.append('sportEventId', config.eventId);

    const response = await fetch(url, requestOptions);
    // setShowIndividualFavoriteLoading(false);
    try {
      const newIndividualFavorites = await handleResponse(response);

      setIndividualFavorites(newIndividualFavorites.data.favorites);
    } catch (error) {
      console.log('error', error);
    }
  };

  const saveFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        favoriteId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event/favorite`);
    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getIndividualFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const deleteFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'DELETE',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        favoriteId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event/favorite`);

    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getIndividualFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const getTeamFavorites = async () => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) {
      return;
    }
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
    };
    const requestOptions = {
      method: 'GET',
      headers,
    };
    let url;

    url = new URL(
      `${config.tncApiUrl}/user-event-team/favorites?orderByTotalDistance=true`
    );

    url.searchParams.append('userId', athlete.user.id);
    url.searchParams.append('sportEventId', config.eventId);

    const response = await fetch(url, requestOptions);
    // setShowIndividualFavoriteLoading(false);
    try {
      const newIndividualFavorites = await handleResponse(response);

      setTeamFavorites(newIndividualFavorites.data.favorites);
    } catch (error) {
      console.log('error', error);
    }
  };

  const saveTeamFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'POST',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        teamId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event-team/favorite`);
    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getTeamFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const deleteTeamFavorite = async (favorite) => {
    const athlete = getLocalUser();
    if (!athlete?.userToken || !athlete?.user?.id) return;
    setShowLoading(true);
    const headers = {
      Authorization: `Bearer ${athlete.userToken}`,
      'Content-Type': 'application/json',
    };
    const requestOptions = {
      method: 'DELETE',
      headers,
      body: JSON.stringify({
        userId: athlete.user.id,
        teamId: favorite,
        sportEventId: config.eventId,
      }),
    };
    const url = new URL(`${config.tncApiUrl}/user-event-team/favorite`);

    await fetch(url, requestOptions);
    setShowLoading(false);
    try {
      getTeamFavorites();
    } catch (error) {
      console.log('error', error);
    }
  };

  const onTabChange = (tab) => {
    setSelectedTab(tab);
    setChangeIndividual(new Date().getTime());
  };

  const renderTable = () => {
    return (
      <TableRankingIndividual
        setShowLoading={setShowLoading}
        setShowSecondLoading={setShowSecondLoading}
        individualFavorites={individualFavorites}
        teamFavorites={teamFavorites}
        saveFavorite={saveFavorite}
        deleteFavorite={deleteFavorite}
        saveTeamFavorite={saveTeamFavorite}
        deleteTeamFavorite={deleteTeamFavorite}
        selectedGenderFilter={selectedGenderFilter}
        selectedTeamGenderFilter={selectedTeamGenderFilter}
        distanceFilter={distanceFilter}
        distanceTeamFilter={distanceTeamFilter}
        changeIndividual={changeIndividual}
        filterText={filterText}
        selectedTab={selectedTab}
        favoritesEnabled={favoritesEnabled}
      />
    );
  };

  return (
    <div className='home'>
      {(showLoading || showIndividualFavoriteLoading || showSecondLoading) && (
        <Loading />
      )}
      {showFilterModal && (
        <FilterModal
          closeModal={() => {
            setShowFilterModal(false);
          }}
          setSelectedGenderFilter={setSelectedGenderFilter}
          setSelectedTeamGenderFilter={setSelectedTeamGenderFilter}
          setDistanceFilter={setDistanceFilter}
          setDistanceTeamFilter={setDistanceTeamFilter}
          selectedGenderFilter={selectedGenderFilter}
          selectedTeamGenderFilter={selectedTeamGenderFilter}
          distanceFilter={distanceFilter}
          distanceTeamFilter={distanceTeamFilter}
          setChangeIndividual={setChangeIndividual}
          selectedTab={selectedTab}
        />
      )}
      {showCollectKitModal && (
        <CollectKitModal
          closeModal={() => {
            setShowCollectKitModal(false);
          }}
        />
      )}
      <Header
        resetFilters={resetFilters}
        showReset={
          !!selectedGenderFilter || !!filterText || !!selectedTeamGenderFilter
        }
      />
      {lastUpdate && (
        <div className='last-update'>
          Última actualización{' '}
          {moment(lastUpdate.lastUpdate).format('DD/MM/YYYY HH:mm')}
        </div>
      )}

      <div className='banner-wrap hide-desktop'>
        <img
          src={bannerMobile}
          alt='12H RUN'
          className='banner banner-mobile'
        />
      </div>
      <div className='banner-wrap hide-mobile'>
        <img
          src={bannerDesktop}
          alt='12H RUN'
          className='banner banner-desktop'
        />
      </div>
      <div className='fixed-header'>
        <Col xs={12} className='sub-header'>
          <Row>
            <Col xs={12} className='tabs-container'>
              <Tabs
                tabs={TABS}
                selectedTab={selectedTab}
                setSelectedTab={setSelectedTab}
                onChange={onTabChange}
              />
            </Col>
            <Col xs={12}>
              <Nav
                filterText={filterText}
                setFilterText={setFilterText}
                selectedTab={selectedTab}
                openFilter={() => {
                  setShowFilterModal(true);
                }}
                distanceFilter={distanceFilter}
                distanceTeamFilter={distanceTeamFilter}
                setDistanceFilter={setDistanceFilter}
                setDistanceTeamFilter={setDistanceTeamFilter}
              />
            </Col>
          </Row>
        </Col>
        <TableRankingTitle />
      </div>
      {renderTable()}
      {/* <div className='wp-fixed'>
        <button
          onClick={() => {
            openIG();
          }}
        >
          <img src={wpicon} alt='wp icon' />
          <p>
            Cotizar una <b>BMC</b> con 10% OFF
          </p>
        </button>
      </div> */}
      <Footer home />
    </div>
  );
};

export default Home;
